// Constantes e microcopy do "Histórico de cliente" (extraídas de HistoricoCliente.vue).
// Mantidas 1:1 com a página original: labels, tons, ícones, opções e copy de estado.
import { LEAD_HISTORY_LOAD_STATES } from 'dashboard/api/leadHistory';

export const HISTORY_TABS_ID = 'lead-history-tabs';

export const HISTORY_TABS = [
  { id: 'overview', label: 'Visão geral' },
  { id: 'imoveis', label: 'Imóveis' },
  { id: 'anotacoes', label: 'Anotações' },
  { id: 'historico', label: 'Histórico' },
];

export const OPERATIONAL_TIMELINE_TYPES = [
  'ownership',
  'online_duty',
  'lead_referral',
  'crm_task',
  'sla',
];

export const TIMELINE_TYPE_META = {
  ownership: {
    label: 'Ownership',
    icon: 'i-lucide-user-check',
    tone: 'bg-[#f8f4fc] text-lais-primary',
  },
  online_duty: {
    label: 'Plantão',
    icon: 'i-lucide-headphones',
    tone: 'bg-sky-50 text-sky-700',
  },
  lead_referral: {
    label: 'Repasse',
    icon: 'i-lucide-forward',
    tone: 'bg-[#fff7ed] text-[#c2410c]',
  },
  crm_task: {
    label: 'Tarefa',
    icon: 'i-lucide-list-checks',
    tone: 'bg-emerald-50 text-emerald-700',
  },
  sla: {
    label: 'SLA',
    icon: 'i-lucide-timer',
    tone: 'bg-rose-50 text-rose-700',
  },
  conversation: {
    label: 'Conversas',
    icon: 'i-lucide-message-circle',
    tone: 'bg-[#f8f4fc] text-lais-primary',
  },
  visita: {
    label: 'Visitas',
    icon: 'i-lucide-calendar-check',
    tone: 'bg-sky-50 text-sky-700',
  },
  offer: {
    label: 'Propostas',
    icon: 'i-lucide-hand-coins',
    tone: 'bg-emerald-50 text-emerald-700',
  },
  favorite: {
    label: 'Favoritos',
    icon: 'i-lucide-heart',
    tone: 'bg-rose-50 text-rose-700',
  },
  recommendation: {
    label: 'Recomendações',
    icon: 'i-lucide-sparkles',
    tone: 'bg-[#fff7ed] text-[#c2410c]',
  },
  property_demand_version: {
    label: 'Demandas',
    icon: 'i-lucide-home',
    tone: 'bg-[#f8f4fc] text-lais-primary',
  },
  reactivation: {
    label: 'Reativação',
    icon: 'i-lucide-rotate-ccw',
    tone: 'bg-[#f8f4fc] text-lais-primary',
  },
};

export const FEEDBACK_SUCCESS_MESSAGE =
  'Obrigada por ajudar a melhorar a Lais! Seu feedback é fundamental para tornar as próximas atualizações ainda melhores.';

export const SUPPORT_UPDATE_PERMISSIONS = [
  'administrator',
  'support_manage',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const SUPPORT_STATUS_META = {
  pending: {
    label: 'Pendente',
    tone: 'bg-amber-50 text-amber-700',
    nextAction: 'Assumir o atendimento ou resolver com motivo registrado.',
  },
  in_progress: {
    label: 'Em atendimento',
    tone: 'bg-sky-50 text-sky-700',
    nextAction: 'Atualizar o atendimento ou finalizar com o motivo.',
  },
  complete: {
    label: 'Resolvido',
    tone: 'bg-emerald-50 text-emerald-700',
    nextAction: 'Acompanhar a trilha privada do atendimento.',
  },
  transferred: {
    label: 'Transferido',
    tone: 'bg-[#fff7ed] text-[#c2410c]',
    nextAction: 'Confirmar se o novo responsável assumiu a conversa.',
  },
};

export const SUPPORT_ORIGIN_LABEL = {
  buyer: 'Comprador',
  buyer_prospect: 'Comprador',
  tenant: 'Locatário',
  tenant_prospect: 'Locatário',
  owner: 'Proprietário',
  owner_prospect: 'Proprietário',
  portal: 'Portal',
  whatsapp: 'WhatsApp',
  unknown: 'Origem não informada',
};

export const SUPPORT_QUESTION_TYPE_LABEL = {
  offer: 'Oferta',
  visit: 'Visita',
  listing: 'Imóvel',
  financing: 'Financiamento',
  document: 'Documento',
  contract: 'Contrato',
  unknown: 'Pergunta não classificada',
};

export const SUPPORT_UPDATE_OPTIONS = [
  { value: 'in_progress', label: 'Marcar em atendimento' },
  { value: 'complete', label: 'Resolver atendimento' },
  { value: 'transferred', label: 'Registrar transferência' },
  { value: 'pending', label: 'Voltar para pendente' },
];

export const UNAVAILABLE_LOAD_STATES = [
  LEAD_HISTORY_LOAD_STATES.ERROR,
  LEAD_HISTORY_LOAD_STATES.FORBIDDEN,
  LEAD_HISTORY_LOAD_STATES.NOT_FOUND,
];

export const PROFILE_STATE_COPY = {
  [LEAD_HISTORY_LOAD_STATES.FORBIDDEN]: {
    title: 'Sem permissão para ver este cliente',
    description:
      'Seu usuário não possui acesso ao perfil solicitado. Revise as permissões da conta.',
  },
  [LEAD_HISTORY_LOAD_STATES.NOT_FOUND]: {
    title: 'Cliente não encontrado',
    description:
      'O contato pode ter sido removido ou não pertence a esta conta.',
  },
  [LEAD_HISTORY_LOAD_STATES.ERROR]: {
    title: 'Desculpe, não foi possível carregar as informações do perfil',
    description: 'Por favor, tente novamente mais tarde.',
  },
};

export const HISTORY_STATE_COPY = {
  [LEAD_HISTORY_LOAD_STATES.FORBIDDEN]: {
    title: 'Sem permissão para ver histórico',
    description:
      'Seu usuário não possui permissão para consultar o histórico deste cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.NOT_FOUND]: {
    title: 'Histórico não encontrado',
    description:
      'A conversa ou o contato solicitado não retornou dados de histórico.',
  },
  [LEAD_HISTORY_LOAD_STATES.ERROR]: {
    title: 'Histórico indisponível',
    description: 'Não foi possível carregar os dados do histórico.',
  },
};

export const CONVERSATION_STATE_COPY = {
  [LEAD_HISTORY_LOAD_STATES.FORBIDDEN]: {
    title: 'Sem permissão para ver conversas',
    description:
      'Seu usuário não possui permissão para consultar as conversas deste cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.NOT_FOUND]: {
    title: 'Conversa não encontrada',
    description: 'A conversa selecionada não está mais disponível.',
  },
  [LEAD_HISTORY_LOAD_STATES.ERROR]: {
    title: 'Conversa indisponível',
    description: 'Não foi possível carregar as conversas deste cliente.',
  },
};

export const VISITAS_STATE_COPY = {
  [LEAD_HISTORY_LOAD_STATES.FORBIDDEN]: {
    title: 'Sem permissão para ver visitas',
    description:
      'Seu usuário não possui permissão para consultar visitas deste cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.NOT_FOUND]: {
    title: 'Visitas não encontradas',
    description: 'Nenhuma agenda de visitas foi encontrada para este cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.ERROR]: {
    title: 'Visitas indisponíveis',
    description: 'Não foi possível carregar as visitas deste cliente.',
  },
};

export const NOTES_STATE_COPY = {
  [LEAD_HISTORY_LOAD_STATES.FORBIDDEN]: {
    title: 'Sem permissão para ver anotações',
    description:
      'Seu usuário não possui permissão para consultar anotações deste cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.NOT_FOUND]: {
    title: 'Anotações não encontradas',
    description: 'Nenhuma anotação foi encontrada para este cliente.',
  },
  [LEAD_HISTORY_LOAD_STATES.ERROR]: {
    title: 'Anotações indisponíveis',
    description: 'Não foi possível carregar as anotações deste cliente.',
  },
};

export const STATUS_LABEL = {
  nao_qualificado: 'Não pronto',
  nao_pronto: 'Não pronto',
  qualificado: 'Qualificado',
  pronto_atendimento: 'Pronto para atendimento',
  pronto: 'Pronto para atendimento',
};

export const PROFILE_STAGE_CLASS = {
  nao_qualificado: 'border-amber-100 bg-amber-50 text-amber-900',
  nao_pronto: 'border-amber-100 bg-amber-50 text-amber-900',
  qualificado: 'border-emerald-100 bg-emerald-50 text-emerald-900',
  pronto_atendimento:
    'border-lais-primary/20 bg-lais-primary-50 text-lais-primary',
  pronto: 'border-lais-primary/20 bg-lais-primary-50 text-lais-primary',
};

export const DEFAULT_PROFILE_STAGE_CLASS =
  'border-lais-border bg-lais-bg-soft text-lais-text';

export const CRM_SYNC_STATUS_META = {
  queued: { label: 'Na fila', cls: 'bg-[#f5eef9] text-lais-primary' },
  processing: { label: 'Processando', cls: 'bg-sky-50 text-sky-700' },
  synced: { label: 'Sincronizado', cls: 'bg-emerald-50 text-emerald-700' },
  failed: { label: 'Falhou', cls: 'bg-rose-50 text-rose-700' },
  skipped: { label: 'Ignorado', cls: 'bg-slate-100 text-slate-700' },
  not_ready: { label: 'Não enviado', cls: 'bg-[#f5f5f5] text-lais-text-body' },
};

export const ATTENDANCE_WINDOW_REASON_LABEL = {
  invalid_whatsapp: 'WhatsApp inválido',
  meta_error: 'Erro Meta',
  bypass_origin: 'Origem sem cobrança',
  invalid_contact: 'Contato inválido',
};
